import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { API_URL } from '../Utils/api';

export const useFollowers = (token) => {
  return useQuery({
    queryKey: ['friends', 'followers'],
    queryFn: async () => {
      if (!token) return [];
      const res = await axios.get(`${API_URL}/amis/followers`, {
        headers: { Authorization: `Bearer${token}` },
      });
      return res.data || [];
    },
    enabled: !!token,
    staleTime: 1000 * 60 * 2,
  });
};

export const useFollowing = (token) => {
  return useQuery({
    queryKey: ['friends', 'following'],
    queryFn: async () => {
      if (!token) return [];
      const res = await axios.get(`${API_URL}/amis/following`, {
        headers: { Authorization: `Bearer${token}` },
      });
      return res.data || [];
    },
    enabled: !!token,
    staleTime: 1000 * 60 * 2,
  });
};

export const useAllFriends = (token) => {
  return useQuery({
    queryKey: ['friends', 'all_friends'],
    queryFn: async () => {
      if (!token) return [];
      const res = await axios.get(`${API_URL}/amis/all_friends`, {
        headers: { Authorization: `Bearer${token}` },
      });
      return res.data || [];
    },
    enabled: !!token,
    staleTime: 1000 * 60 * 2,
  });
};
